import React, { memo } from 'react';
import { string, func, element, bool, number, object, shape, node, oneOfType, arrayOf } from 'prop-types';
import { InputAdornment } from '@material-ui/core';

import { Container, TextInput } from './styles';

function CustomTextField({
  label,
  name,
  type,
  placeholder,
  helperText,
  error,
  value,
  onChange,
  fullWidth,
  icon,
  margin,
  color,
  disabled,
  multiline,
  rows,
  inputProps,
  InputLabelProps,
  select,
  children,
}) {
  return (
    <Container margin={margin}>
      <TextInput
        label={label}
        name={name}
        type={type}
        placeholder={placeholder}
        helperText={helperText}
        error={error}
        value={value}
        onChange={onChange}
        fullWidth={fullWidth}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        inputProps={inputProps}
        InputLabelProps={InputLabelProps}
        InputProps={{
          startAdornment: icon && (
            <InputAdornment position="start">{icon}</InputAdornment>
          ),
        }}
        color={color}
        select={select}
      >
        {children}
      </TextInput>
    </Container>
  );
}

CustomTextField.propTypes = {
  label: string,
  name: string,
  type: string,
  placeholder: string,
  helperText: string,
  error: bool, // Material-UI usa boolean para error
  value: string,
  onChange: func,
  fullWidth: bool,
  icon: element,
  margin: string,
  color: string,
  disabled: bool,
  multiline: bool,
  rows: number,
  inputProps: object,
  InputLabelProps: object,
  select: bool,
  children: oneOfType([node, arrayOf(node)]),
};

CustomTextField.defaultProps = {
  label: '',
  name: '',
  type: 'text',
  placeholder: '',
  helperText: '',
  error: false, // Material-UI usa boolean para error
  value: '',
  fullWidth: false,
  icon: null,
  onChange: () => {},
  margin: null,
  color: 'primary',
  disabled: false,
  multiline: false,
  rows: undefined,
  inputProps: undefined,
  InputLabelProps: undefined,
  select: false,
  children: null,
};

export default memo(CustomTextField);
